import type { App } from 'vue'
import { computed, ref } from 'vue'
import { I18n } from 'i18n-js'
import en from './lang/en.json'
import ru from './lang/ru.json'
import rs from './lang/rs.json'
import kz from './lang/kz.json'
import { languages } from './model/model'

/** Default UI locale when nothing is stored and for `setLocale(undefined)`. */
export const DEFAULT_APP_LOCALE = 'ru' as const

const i18n = ref(
  new I18n({
    en,
    ru,
    rs,
    kz,
  }),
)

/* Plugin install */
const Translate = {
  install(app: App): void {
    i18n.value.locale = localStorage.getItem('lang') || DEFAULT_APP_LOCALE

    app.config.globalProperties.$t = (string: string, variables?: any, defaultValue?: string) => {
      return i18n.value.t(string, {
        defaultValue: defaultValue || string,
        ...variables,
      })
    }
  },
}

/** Translation helpers for use outside templates */
export const useTranslate = () => {
  const trs = (string: string, variables?: any, defaultValue?: string): string => {
    return i18n.value.t(string, {
      defaultValue: defaultValue || string,
      ...variables,
    })
  }

  const setLocale = (locale: string = DEFAULT_APP_LOCALE): void => {
    i18n.value.locale = locale
    localStorage.setItem('lang', locale)
  }

  const getLocale = (): string => {
    return i18n.value.locale
  }

  const getLocaleValue = (): string => {
    return languages[getLocale()]
  }

  const lang = computed(() => {
    const langs: { title: string; value: string }[] = []

    Object.keys(languages).forEach((lang) => {
      langs.push({
        value: lang,
        title: languages[lang] as string,
      })
    })

    return langs
  })

  return {
    languages,
    lang,

    trs,
    setLocale,
    getLocale,
    getLocaleValue,
  }
}

export default Translate
export * from './model/model'
